<div class="row pl-2 pr-2">
    <div class="topCategoryContainer"
        [ngClass]="{'mb-6': gutterBottom}"
        [ngStyle]="currentStyles"
        >
        <div *ngFor="let catItem of topLevelCategories" role="presentation" class="text-unselectable topCategoryTab"
            id="topTab{{catItem.categoryId}}" (click)="onSelectTopLevelCategory(catItem.categoryId)">
            <div class="topCatetoryImage" [style.background-image]="getBackgroundImage(catItem.standardImage)">
            </div>
            {{catItem.name}}
        </div>
        <div *ngIf="hasOtherTopLevelCategories" role="presentation" class="text-unselectable topCategoryTab"
            (click)="onSelectTopLevelCategory(null)">
            <div class="topCatetoryImage"></div>
            Others
        </div>
    </div>
</div>